/**
 * @generated SignedSource<<d35bef7bdc6c01883036f0dc59eda9a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type pipelineParentProjectFragment$data = {
  readonly id: Branded<string, 'ProjectId'> | null | undefined;
  readonly internalId: Branded<string, 'ProjectInternalId'> | null | undefined;
  readonly " $fragmentType": "pipelineParentProjectFragment";
};
export type pipelineParentProjectFragment$key = {
  readonly " $data"?: pipelineParentProjectFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"pipelineParentProjectFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "pipelineParentProjectFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "internalId",
      "storageKey": null
    }
  ],
  "type": "ProjectRest",
  "abstractKey": null
};

(node as any).hash = "827ab6242fbbf4631ec7d4a3dcdb2051";

export default node;
